import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CreateLabelPrinterDeviceCommand, RemoveLabelPrinterCommand, UpdateLabelPrinterCommand } from '@shared/models/commands';
import { ILabelPrinter } from '@shared/models';


export const LabelPrinterActions = createActionGroup({
  source: 'LabelPrinter',
  events: {
    'Reset': emptyProps(),

    'Add': props<{ command: CreateLabelPrinterDeviceCommand }>(),
    'Add Success': props<{ labelPrinter: ILabelPrinter }>(),
    'Add Failure': props<{ error: any }>(),

    'Remove': props<{ command: RemoveLabelPrinterCommand }>(),
    'Remove Success': props<{ id: string }>(),
    'Remove Failure': props<{ error: any }>(),

    'Update': props<{ id: string; command: UpdateLabelPrinterCommand }>(),
    'Update Success': props<{ labelPrinter: ILabelPrinter }>(),
    'Update Failure': props<{ error: any }>(),

    'Load': emptyProps(),
    'Load Success': props<{ labelPrinters: ILabelPrinter[] }>(),
    'Load Failure': props<{ error: any }>(),

    'Get': props<{ printerId: string }>(),
    'Get Success': props<{ labelPrinter: ILabelPrinter }>(),
    'Get Failure': props<{ error: any }>(),
  },
});